module.exports = __webpack_public_path__ + "static/media/Hair.64bad9bb.png";